import { FC } from 'react';

import { CallInvitation } from '../CallInvitation/CallInvitation';
import { BackgroundImage } from './Components/BackgroundImage/BackgroundImage';
import { WrapperContent } from './Components/WrapperContent/WrapperContent';

export const CallInvitationPage: FC = () => {
  return (
    <>
      <BackgroundImage />
      <WrapperContent>
        <CallInvitation />
      </WrapperContent>
    </>
  );
};
